enum FactorIssueTypes {
    Real = 1,
    Legal = 2

}

export default FactorIssueTypes